import type { FC } from 'react';
import React, { useState, useEffect, useCallback } from 'react';

import { LoadableLazy } from '@confluence/loadable';

// Modal state management
type Listener = () => void;

const listeners: Set<Listener> = new Set();

export const openSingleImportModal = (): void => {
	listeners.forEach((listener) => listener());
};

const useSingleImportModalState = (): [boolean, () => void] => {
	const [isOpen, setIsOpen] = useState(false);

	useEffect(() => {
		const handleOpen = () => {
			setIsOpen(true);
		};

		listeners.add(handleOpen);
		return () => {
			listeners.delete(handleOpen);
		};
	}, []);

	const closeModal = useCallback(() => {
		setIsOpen(false);
	}, []);

	return [isOpen, closeModal];
};

// Modal component
const SingleImportModalLoader = LoadableLazy({
	loader: async () =>
		(await import(/* webpackChunkName: "loadable-SingleImportModal" */ './SingleImportModal.tsx'))
			.SingleImportModal,
});

export const ConditionalSingleImportModal: FC = () => {
	const [isOpen, closeModal] = useSingleImportModalState();

	return isOpen ? <SingleImportModalLoader isOpen={isOpen} onClose={closeModal} /> : null;
};
